export default function WindowLanguage() {
    if(navigator.language==='ko' || navigator.language==='ko-KR')
      return 'ko'
    else {
      return 'en'
    }
}
